import { IconButton } from "@mui/material";
import React, { FC } from "react";
import RefreshIcon from "@mui/icons-material/Refresh";

interface RefreshButtonProps {
  refetch: () => void;
}

export const RefreshButton: FC<RefreshButtonProps> = ({ refetch }) => {
  return (
    <IconButton onClick={refetch} sx={{ mr: 0 }}>
      <RefreshIcon />
    </IconButton>
  );
};
